import React from "react";
import { Row, Col } from "reactstrap";
import StatTile from "./StatTile";

/**
 * Compact row of StatTile widgets. Convenience wrapper that takes a
 * single `stats` array and renders a responsive Row/Col grid so every
 * landing page doesn't repeat the same 30-line Row block.
 *
 * Pure presentation — no fetching. Pass loading=true to render every
 * tile in skeleton state.
 *
 * Props
 *  - stats:       array of { label, value, icon, tone, suffix?, onClick? }
 *  - loading:     bool — overrides each tile's loading flag
 *  - columns:     breakpoint map (default { xl: 3, md: 6 } — same as Mafia)
 *  - gutter:      g-* gutter class number (default 3)
 *  - subtle:      bool — render all tiles in subtle mode (no top accent
 *                 bar) for less-prominent stat groups
 *  - className:   extra className on the outer wrapper
 */
const CompactStatsRow = ({
  stats = [],
  loading = false,
  columns = { xl: 3, md: 6 },
  gutter = 3,
  subtle = false,
  className = "",
}) => {
  if (!Array.isArray(stats) || stats.length === 0) return null;

  return (
    <Row className={`g-${gutter} ${className}`}>
      {stats.map((s, i) => (
        <Col {...columns} key={s.key || s.label || i}>
          <StatTile
            icon={s.icon}
            label={s.label}
            value={s.value}
            suffix={s.suffix}
            tone={s.tone}
            loading={loading || s.loading}
            onClick={s.onClick}
            subtle={subtle || s.subtle}
            duration={s.duration}
          />
        </Col>
      ))}
    </Row>
  );
};

export default React.memo(CompactStatsRow);
